<script setup>

import {ref} from 'vue'
import {useAuthStore} from "@/stores/auth.store";
import {useAccountsStore} from "@/stores/account.store";
import {storeToRefs} from 'pinia';


const authStore = useAuthStore();
const accountsStore = useAccountsStore();
accountsStore.fetchAll();

const {accounts} = storeToRefs(accountsStore);
const email = ref('');
const password = ref('');
const firstName = ref('');
const lastName = ref('');
const nickname = ref('');
const accountId = ref(1);

const register = async () => {
  await authStore.register(email.value, password.value, firstName.value, lastName.value, accountId.value, nickname.value);
}

</script>

<template>
  <van-form @submit="register">
    <van-space direction="vertical" fill>
      <van-row justify="center">
        <van-image
            src="./logo.png"
        />
      </van-row>
      <van-row justify="center">
        <b>Personal Information</b>
      </van-row>
      <van-cell-group inset>
        <van-field
            v-model="firstName"
            label="First Name"
            placeholder="First Name"
            required
            :rules="[{ required: true, message: 'Please input first name' }]"
        />
        <van-field
            v-model="lastName"
            label="Last Name"
            placeholder="Last Name"
            required
            :rules="[{ required: true, message: 'Please input last name' }]"
        />
        <van-field
            v-model="nickname"
            label="Nickname"
            placeholder="Nickname"
        />
      </van-cell-group>


      <van-row justify="center">
        <b>Login Information</b>
      </van-row>
      <van-cell-group inset>
        <van-field
            v-model="email"
            name="email"
            label="Email"
            placeholder="Email"
            required
            :rules="[{ required: true, message: 'Please input email' }]"
        />
        <van-field
            v-model="password"
            type="password"
            name="Password"
            label="Password"
            placeholder="Password"
            required
            :rules="[{ required: true, message: 'Please input password' }]"
        />
      </van-cell-group>

      <van-row justify="center">
        <b>Select Clinics</b>
      </van-row>

      <van-cell-group>
        <van-radio-group v-model="accountId">
          <van-cell-group inset>
            <van-cell v-for="account in accounts" :key="account.id" :title="account.name" clickable
                      @click="accountId = account.id">
              <template #right-icon>
                <van-radio :name="account.id" :checked="accountId === account.id"/>
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-cell-group>

      <van-row justify="center">
        <p>
          Already have an account?
          <router-link to="/login">Login</router-link>
        </p>
      </van-row>
      <van-divider/>
      <van-cell-group inset>
        <van-button block round type="success" native-type="submit">
          Register
        </van-button>
      </van-cell-group>
    </van-space>
  </van-form>
</template>
